import {MoreAboutPerson} from './common/MoreAboutPerson';

export class Person {
  id: number;
  partnerId: number;
  enterpriseId: number;
  enterpriseIdView: number;
  countryId: number;
  enterpriseName: string;
  type: number;
  documentType: number;
  documentId: number;
  documentNumber: string;
  certificateSerialNumber: string;
  firstname: string;
  lastname: string;
  lastname2: string;
  fullname: string;
  createAt: string;
  cellphone: string;
  active: number | any;
  email: string;
  roles: string;
  workflows: string;
  valuesidentity: string;
  scope: number;
  jobId: number;
  replaceable: number;
  replaced: number;
  observation: string;
  orderParticipant: number;
  password: string;
  oldPassword: string;
  repeatNewPassword: string;
  newPassword: string;
  rubricBase64Data: string;
  rubricFilename: string;
  documentFrontBase64Data: string;
  documentFrontFilename: string;
  documentRearBase64Data: string;
  documentRearFilename: string;
  hasPowerValidity: boolean;
  hasRUCFile: boolean;
  file: string;
  filename: string;
  rucFileBase64Data: string;
  rucFilename: string;
  labelIds: number[];
  labels: string;
  found: boolean;
  // tslint:disable-next-line:variable-name
  _more: MoreAboutPerson;
  moreAboutPerson?: MoreAboutPerson;
}

